import { Component, Vue } from 'vue-property-decorator'

import store from '@/store'

@Component
export default class ProjectLimitsMixin extends Vue
{
	get canCreateProject()
	{
		return this.projects.length < this.maxProjects
	}

	get maxProjects()
	{
		return this.$store.getters['userMetaData/maxProjects']
	}

	get projects()
	{
		return store.getters['projects/projects']
	}
}
